export const REGION = 'ap-northeast-1';

// Auth
export const awsconfig = {
  test: {
    Auth: {
      Cognito: {
        userPoolId: 'userPoolId',
        userPoolClientId: 'userPoolClientId',
        identityPoolId: 'identityPoolId',
      },
    },
  },
  development: {
    Auth: {
      Cognito: {
        userPoolId: 'ap-northeast-1_ZVJ4MIvyO',
        userPoolClientId: '78de3l5l3p449r47as1373jefk',
        identityPoolId: 'ap-northeast-1:7f05851d-5ca1-4df4-adc9-60f1e43d1434',
      },
    },
  },
  staging: {
    Auth: {
      Cognito: {
        userPoolId: 'ap-northeast-1_GtAU9Cf3o',
        userPoolClientId: '1t5b862h9h5noellkhjsm3m1nh',
        identityPoolId: 'ap-northeast-1:86ca270c-b58b-40ed-b4d4-3a4c6050739c',
      },
    },
  },
  production: {
    Auth: {
      Cognito: {
        userPoolId: 'ap-northeast-1_ujv2D1ztR',
        userPoolClientId: '183u75oj52edbine8h2vm0cg8o',
        identityPoolId: 'ap-northeast-1:b285d8f9-2821-485b-800f-f908f3018e71',
      },
    },
  },
};

// IoT
export const AWSIOT_POLICY_NAME = {
  test: 'iotPolicyName',
  development: 'radiowavemonitoring-gateway-frontend-dev-iotstack-Dev_RadioWave-iotpolicy',
  staging: 'radiowavemonitoring-gateway-frontend-stg-iotstack-Stg_RadioWave-iotpolicy',
  production: 'radiowavemonitoring-gateway-frontend-prd-iotstack-Prd_RadioWave-iotpolicy',
};

// IoT: Device Shadow
export const AWSIOT_DATA_ENDPOINT = {
  test: 'iotDataEndpoint',
  development: 'https://a30rzkua555f9z-ats.iot.ap-northeast-1.amazonaws.com',
  staging: 'https://a3cjbbz2neingi-ats.iot.ap-northeast-1.amazonaws.com',
  production: 'https://a4a002dfch036-ats.iot.ap-northeast-1.amazonaws.com',
};

// IoT: MQTT
export const iotconfig = {
  test: {
    region: REGION,
    endpoint: 'mqttEndpoint',
  },
  development: {
    region: REGION,
    endpoint: 'wss://a30rzkua555f9z-ats.iot.ap-northeast-1.amazonaws.com/mqtt',
  },
  staging: {
    region: REGION,
    endpoint: 'wss://a3cjbbz2neingi-ats.iot.ap-northeast-1.amazonaws.com/mqtt',
  },
  production: {
    region: REGION,
    endpoint: 'wss://a4a002dfch036-ats.iot.ap-northeast-1.amazonaws.com/mqtt',
  },
};

// API
export const PF_API_ENDPOINT = {
  test: 'apiEndpoint',
  development: 'https://api.dev.wsn-cloud-service.com',
  staging: 'https://api.stg.wsn-cloud-service.com',
  production: 'https://api.wsn-cloud-service.com',
};
export const PF_API_STAGE = 'v1';

// S3
export const IMAGE_BUCKET = {
  test: 'imageBucket',
  development: 'radio-wave-monitoring-gateway-frontend-mapimage-dev',
  staging: 'radio-wave-monitoring-gateway-frontend-mapimage-stg',
  production: 'radio-wave-monitoring-gateway-frontend-mapimage-prd',
};

export const MANUAL_BUCKET = {
  test: 'manual-test-bucket',
  development: 'manual-dev-bucket',
  staging: 'manual-stg-bucket',
  production: 'manual-prd-bucket',
};
